import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("pdfConstructor", {
    openPdfConstructor: 'Open PDF constructor',
    lines: 'List',
    tiles: 'Tile',
    grid: 'Grid',
    horizontal: "Horizontal",
    vertical: "Vertical",
});
